<template>
  <div class="christmas">
    <div class="header">
      <div class="left">
        <router-link to="/index"><i class="logo"></i></router-link>
      </div>
      <div class="right">
        <a @click="switchMode()" v-if="mode==0">{{ $t("index_txtSwitchToPython")}}</a>
        <a @click="switchMode()" v-else>{{ $t("index_txtSwitchToBlocky")}}</a>
        <router-link to="/index">{{ $t("sucPass_button") }}</router-link>       
      </div>

    </div>

    <div class="container">
      <!-- VIP用户显示公告 -->
      <div 
        v-if="isVip==1" class="announcement" :class="{ announcement__EN: lang === 'en' }">
        <div class="msgBox">
          <b v-html="announce" v-if="$i18n.locale == 'zh'"></b>
          <b v-html="announce_en" v-else></b>
        </div>
        <img
          src="~@/assets/images/event/Christmas2020/santa.png"
          width="140px"
          height="140px"
        />
      </div>
      <!-- 非VIP用户提示购买 -->
      <div v-else class="announcement" :class="{ announcement__EN: lang === 'zh' }">
        <div class="msgBox">
          <div>
            <b v-html="announce2" v-if="lang == 'zh'"></b>
            <b v-html="announce2_en" v-else></b>
            <br/>
            <button @click="toVipPage()">
              <b v-if="lang == 'zh'">升级为正式宇航员</b>
              <b v-else>Upgrade to VIP</b>
            </button>
          </div>
        </div>
        <img
          src="~@/assets/images/event/Christmas2020/santa2.png"
          width="140px"
          height="140px"
        />
      </div>

      <div class="myScore" :class="{ myScore__EN: lang === 'en' }">
        <div class="msgBox">
          <section>
            <div class="msgBox-left" v-if="lang == 'zh'">通关关卡</div>
            <div class="msgBox-left" v-else>Levels</div>
            <div class="msgBox-right">{{ rankPoints }}</div>
          </section>
          <section>
            <div class="msgBox-left" v-if="lang == 'zh'">收集礼物</div>
            <div class="msgBox-left" v-else>Score</div>
            <div class="msgBox-right">
              <i class="gift-icon"></i>
              <span> x {{ giftNumber }}</span>
            </div>
          </section>
        </div>
      </div>

      <div class="enterBtn">
        <section></section>
        <section v-if="mode == 1">
          
            <a
              class="enterBtn-py"
              :class="{ 'enterBtn-py__EN': lang === 'en' }"
              @click="enterEventGame()"
              v-if="isVip == 1"
            ></a>
            <el-tooltip :content="$t('index_txt49_noOpen')" placement="top">
              <a
                class="enterBtn-py-non"
                :class="{ 'enterBtn-py-non__EN': lang === 'en' }"
                v-if="isVip == 0"
              ></a>
            </el-tooltip>
        </section>

        <section v-else>
          
            <a
              class="enterBtn-blocky"
              :class="{ 'enterBtn-blocky__EN': lang === 'en' }"
              @click="enterEventGame()"
              v-if="isVip == 1"
            ></a>
            <el-tooltip :content="$t('index_txt49_noOpen')" placement="top">
              <a
                class="enterBtn-blocky-non"
                :class="{ 'enterBtn-blocky-non__EN': lang === 'en' }"
                v-if="isVip == 0"
              ></a>
            </el-tooltip>
        </section>
        <section>
          <a @click="switchMode()" v-if="mode==0">{{ $t("index_txtSwitchToPython")}}</a>
          <a @click="switchMode()" v-else>{{ $t("index_txtSwitchToBlocky")}}</a>
        </section>
       
      </div>

      <a
        class="rankSearch"
        :class="{ rankSearch__EN: lang === 'en' }"
        @click="
          (rankBoard = true), rankListSearch(pageSize, pageStart)
        "
      ></a>
    </div>

    <el-dialog
      class="christmas-rankBoard"
      :visible.sync="rankBoard"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div
        class="christmas-rankBoard__container"
        :class="{ 'christmas-rankBoard__container__EN': lang === 'en' }"
      >
        <div
          class="rankBoard"
          v-loading="rankBoardLoading"
          element-loading-spinner="el-icon-loading"
          :element-loading-text="
            lang == 'zh'
              ? '排行榜数据读取中，请稍候...'
              : lang == 'en'
              ? 'Loading...'
              : ''
          "
          element-loading-background="rgba(255, 255, 255, 0.95)"
        >
          <div class="rankBoard-content">
            <el-table :data="listQuery">
              <el-table-column
                prop="rank"
                :label="lang == 'zh' ? '排名' : lang == 'en' ? 'Rank' : ''"
                width="80"
                align="center"
              ></el-table-column>

              <el-table-column
                :label="lang == 'zh' ? '姓名' : lang == 'en' ? 'Name' : ''"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="vipName" v-if="scope.row.isVip == 1">
                    {{
                      // 如果长度大于6，省略后面的字符并句尾加上“...”
                      scope.row.firstName.length > 6
                        ? scope.row.firstName.substring(0, 6) + "..."
                        : scope.row.firstName
                    }}</span
                  >
                  <span v-else>{{
                    // 如果长度大于6，省略后面的字符并句尾加上“...”
                    scope.row.firstName.length > 6
                      ? scope.row.firstName.substring(0, 6) + "..."
                      : scope.row.firstName
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                :label="lang == 'zh' ? '学校' : lang == 'en' ? 'School' : ''"
                align="center"
              >
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.schoolCnName.length > 20
                        ? scope.row.schoolCnName.substring(0, 20) + "..."
                        : scope.row.schoolCnName
                    }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                :label="lang == 'zh' ? '收集礼物' : lang == 'en' ? 'Score' : ''"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="giftGetting">
                    <i class="gift-icon"></i>
                    <span>{{ scope.row.totalScore }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页器 -->
          <div class="rankBoard-pagination">
            <el-pagination
              class="rankBoard-pagination__container"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page.sync="pageStart"
              :page-size="pageSize"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>

        <div
          class="progressBar"
          v-loading="rankBoardLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.95)"
        >
          <div class="bar">
            <div class="bar-count">
              <span>
                {{ currentProgressNum }} / {{ currentProgressTotalNum }}
              </span>
            </div>
            <el-progress class="bar-top" :percentage="percentage"></el-progress>
            <div class="bar-bg"></div>
          </div>

          <p>
            <span v-if="lang === 'zh'">{{ currentProgressAward }}</span>
            <span v-if="lang === 'en'">{{ currentProgressAward_EN }}</span>
            <!-- <el-tooltip placement="top">
              <div
                slot="content"
                v-if="lang == 'zh'"
                v-html="rewardTootip"
              ></div>
              <div
                slot="content"
                v-if="lang == 'en'"
                v-html="rewardTootip_EN"
              ></div>
              <i class="el-icon-question"></i>
            </el-tooltip> -->
          </p>
        </div>

        <div class="closeBtn" @click="rankBoard = false"></div>
      </div>
    </el-dialog>

    <YUKI />
  </div>
</template>

<script>
import YUKI from "./snowANDrain/index.vue";
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {
    return {
      rankBoardLoading: true,
      // 排行榜默认不显示
      rankBoard: false,

      // VIP标识
      isVip: 1,

      eventCode: 221225,
      mode: 0,
      channel: "christmas",

      // 用户信息
      userForm: {
        name:"",
        MD5psw: "",
        gameId: "",
        mode: ""
      },

      // 公告
      announce:
        "欢迎来到圣诞特训！<br>请点击下方按钮开始冒险，<br><br>尽情享受节日的快乐，<br>和大家齐心解锁更多关卡吧！",
      announce_en:
        "Merry Christmas!<br>Please click the button below<br>to start the adventure,<br>Enjoy the joy of celebration,<br>Unlock more rewards together!",
      announce2:
        "您还不是正式宇航员，<br>无法参加圣诞特训活动哦！<br/>赶紧点击下面的按钮，<br>升级成为正式宇航员吧！",
      announce2_en:
        "You are not a VIP user yet,<br>Can't join in the celebration!<br>Click the button below,<br>Upgrade to a VIP user!",
      // 我的成绩
      rankPoints: 0,
      giftNumber: 0,

      // 进度条（百分比）初始化
      percentage: 0,
      // 当前玩家总分 初始化
      currentProgressNum: 0,
      // 当前进度条总分 【随版本更新】(包含同步更新页面中的圣诞树的图片)
      currentProgressTotalNum: 180000,
      // 进度条下方奖励字符 【随版本更新】(包含同步更新页面中的圣诞树的图片)
      currentProgressAward: "全部50关地图都已解锁，活动将于2月10日24点结束，抓紧时间闯关，一起挑战18万总分目标吧！",
      currentProgressAward_EN:
        "All 50 levels have been unlocked, and the activity will end at 24:00 on February 10. Let's challenge the new goal together!",
      rewardTootip:
        "1.在2020年12月18日至2021年1月3日期间，累计购买3个月以上的正式宇航员，则活动赠送时长翻倍。<br/><br/>2.截止2020年1月3日24点，累计购买正式宇航员时长超过12个月的用户，可以参加新年福袋抽奖。",
      rewardTootip_EN:
        "1.During the period from December 18, 2020 to January 3, 2021,<br/>if you have purchased the qualify astronaut for more than 3 months,the rewards for the qualify astronauts will be doubled.<br/><br/>2. As of 24:00 on January 3, 2020,<br/>users who have purchased the qualify astronaut for more than 12 months can participate in the New Year lucky bag draw.",
      listQuery: [],

      // blocky模式和python模式的gameId
      gameId: 22122501,

      // pagination
      pageStart: 1,
      pageSize: 10,
      totalNum: 0,

      startGameShow: false,
      startGameHint: "圣诞特训仅向正式宇航员开放",
      startGameShow2: false,
      startGameHint2: "登录出错，请重新登录账号",

      // "X"默认 = “zh”, "V" = "en"
      lang: "",
    };
  },

  components: {
    YUKI,
  },

  methods: {

    async getMsg() {
      try {
        let res = await this.$http.getAxios("/user/queryUserInfo");
        // code=0 -> 用户登录成功
        if (res.data.code == "0") {
          // 设置 tipShow
          this.isVip = res.data.data.isVip;
          this.userForm.name = res.data.data.mobile ? res.data.data.mobile : res.data.data.userAccount;
          this.userForm.MD5psw = res.data.data.password;


          // 存储作用暂时不明
          this.$store.commit("toggleMaskState", false);
          this.$store.commit("setUserType", res.data.data.userType);
          this.$store.commit("setUserName", this.psnMsg.yourname);
          localStorage.setItem("userType", res.data.data.userType);
          localStorage.setItem("names", this.psnMsg.yourname);
        }
        // code=5 -> 获取用户信息缺失
        else if (res.data.code == "5") {
          this.$router.push({ path: "/signIn" });
          return;
        }
        // code=others -> 获取到未知code值将会直接返回登录首页
        else {
          this.$router.push({ path: "/" });
          return;
        }
      } catch (err) {
        console.log(err);
      }

      this.getScoreANDlevel();
    },

    async getScoreANDlevel() {
      try {
        this.$http
          .getAxios("user/queryUserSchoolRanks", {
            method: "get",
            params: {
              gameId: this.gameId,
            },
          })
          .then((res) => {
            var c = res.data;

            if (c.code == "0") {
              // this.name = c.data.lastName + c.data.firstName;
              // this.name = c.data.firstName;
              this.giftNumber = c.data.userScore;
              this.rankPoints = c.data.totalLevel;
            } else {
              this.$notify.error({
                title: "ERROR",
                message: "LOGIN ERROR, PLEASE RELOGIN",
              });
            }
          });
      } catch (e) {
        this.$notify.error({
          title: "ERROR",
          message: "ERROR MSG: " + e,
        });
      }
    },

    handleCurrentChange(val) {
      this.rankListSearch(this.pageSize, val);
    },

    // 开始游戏
    sendEnterGame() {
      this.$http
        .getAxios(`/user/enterGame`, {
          method: "post",
          data: {
            mode: this.mode,
            gameId: this.gameId,
            channel: this.channel, // 决赛
          },
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            let urls =
              process.env.GO_IDE +
              "?highLevel=1&mode=" +
              this.userForm.mode +
              "&game=" +
              this.userForm.gameId +
              "&channel=" +
              this.channel;

            window.location.href = urls;
          } else if (res.code == "119") {
            this.$notify.error({
              title: "错误",
              message: "您不可以参加该比赛",
            });
          } else if (res.code == "49") {
            this.$notify.error({
              title: "错误",
              message: "比赛未开始",
            });
          } else if (res.code == "50") {
            this.$notify.error({
              title: "错误",
              message: "比赛已结束",
            });
          } else if (res.code == "122") {
            this.$notify.error({
              title: "错误",
              message: "比赛不存在，请联系ICode管理员",
            });
          } else if (res.code == "123") {
            this.$notify.error({
              title: "错误",
              message: "比赛未配置完成，有疑问请联系ICode管理员",
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: "错误信息：" + res.msg,
            });
          }
        });
    },

    enterEventGame() {
      let gameId = this.gameId;
      let mode = this.mode;
      try {
        this.$http
          // .getAxios("/user/userLogin", {
          // 决赛API
          .getAxios("/user/channel/userLogin", {
            // 初赛API
            method: "post",
            data: {
              email: this.userForm.name,
              password: this.userForm.MD5psw,
              eventCode: this.eventCode, 
            },
          })
          .then((res) => {
            const _res = res.data;
            if (_res.code == "0") {
              this.loading = false;
              this.userForm.gameId = gameId;
              this.userForm.mode = mode;
              // this.$notify({
              //   type: "success",
              //   title: "成功",
              //   message: "登录成功",
              // });
              this.sendEnterGame();
            } else if (_res.code == "120") {
              this.loading = false;
              this.$notify({
                type: "error",
                title: "错误",
                message: "账号已存在但未报名活动",
              });

              // 用户名错误 = 用户未注册
            } else if (_res.code == "46") {
              this.loading = false;
              this.$notify({
                type: "error",
                title: "错误",
                message: _res.msg,
              });
              // 密码错误
            } else if (_res.code == "47") {
              this.loading = false;
              this.$notify({
                type: "error",
                title: "错误",
                message: _res.msg,
              });
            } else if (_res.code == "30001") {
              this.loading = false;
              this.$notify({
                type: "error",
                title: "Error",
                message: "未知错误, 错误码:30001",
              });
            } else {
              this.loading = false;
              this.$notify({
                type: "error",
                title: "Error",
                message: "Undefined error",
              });
            }
          });
      } catch (e) {
        this.loading = false;
        // console.log(e);
      }
    },

    rankListSearch(pageSize, pageStart) {
      this.listQuery = [];
      this.percentage = 0;
      this.rankBoardLoading = true;

      setTimeout(() => {
        this.$http
          .getAxios("rank/queryUserLeaderboard", {
            method: "get",
            params: {
              gameId: this.gameId,
              pageSize: pageSize,
              pageStart: pageStart,
              edition: this.mode,
            },
          })
          .then((res) => {
            var res = res.data;

            if (res.code == 0) {
              this.listQuery = res.data;
              this.pageStart = pageStart;
              this.totalNum = res.total;
            } else {
              this.$notify.error({
                title: "错误",
                message: res.msg,
              });
            }
          });

        this.$http
          .getAxios("event/getTotalScore", {
            method: "get",
            params: {
              eventCode: this.eventCode,
            },
          })
          .then((res) => {
            var res = res.data;

            if (res.code == 0) {
              // 如果API传回分值超过当前进度总数值，就显示 [当前进度总数值 / 当前进度总数值]，否则 [当前进度数值 / 当前进度总数值]
              this.currentProgressNum =
                res.msg > this.currentProgressTotalNum
                  ? this.currentProgressTotalNum
                  : res.msg;

              // 计算进度条 最大值100
              this.percentage =
                this.percentage >= 100
                  ? 100
                  : (this.currentProgressNum / this.currentProgressTotalNum) *
                    100;
            } else {
              this.$notify.error({
                title: "错误",
                message: res.msg,
              });
            }
          });

        this.rankBoardLoading = false;
      }, 1250);
    },

    toVipPage() {
      this.$router.push("/wechat");
    },


    switchMode() {
      this.mode = this.mode == 0 ? 1 : 0;
      this.gameId = this.eventCode * 100 + (this.mode == 0 ? 1 : 11);
      this.getScoreANDlevel();
    }
  },

  mounted() {
    this.getMsg();
    I18nUtils.initLanguage(this);
    this.lang = this.$i18n.locale;
  },
};
</script>

<style lang="scss">
$christmas2020_color_one: #461000;

.christmas {
  width: 100vw;
  height: 100vh;
  // min-width: 960px;
  background: url("~@/assets/images/event/Christmas2020/bg-4.png") center /
    cover no-repeat;
  overflow: hidden;

  // 活动页全局a去除underline
  a {
    text-decoration: none;
    transition: 0.4s ease all;

    &:hover {
      color: #ff9bad;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 6.5vh;
    background: #122346;
    color: #aaf9fe;
    font-size: 1.7vh;
    font-weight: bold;

    .left {
      margin-left: 1.5vw;
      height: 100%;

      .logo {
        display: block;
        height: 100%;
        width: 9vw;
        margin-left: 0.5vw;
        background: url("~@/assets/images/bigIcon.png") center / contain
          no-repeat;
      }
    }

    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      margin-right: 1.5vw;
      font-size: 0.9vw;

      a {
        cursor: pointer;
        margin: 1.5vw;
      }
    }
  }

  .container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .announcement,
    .myScore,
    .enterBtn {
      position: fixed;
      right: 17vw;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      width: 516px;
    }

    .announcement {
      bottom: 430px;
      height: 312px;
      background: url("~@/assets/images/event/Christmas2020/board1.png") center /
        100% auto no-repeat;
      z-index: 9;

      justify-content: flex-start;
      padding-left: 20px;

      img {
        position: absolute;
        top: 70px;
        right: 90px;
      }

      button {
        width: 180px; 
        height: 30px; 
        margin-top: 12px; 
        background-color: darkred; 
        color: white;
        border-radius: 5px;
        border: 2px solid #49190fce;
        &:hover {
          color: #fffc51;
          background: #092a49;
          scale:1.05;
          cursor: pointer;
        }
      }

      .msgBox {
        padding: 40px;
        color: $christmas2020_color_one;
        cursor: default;
      }

      &__EN {
        background-image: url("~@/assets/images/event/Christmas2020/board1-EN.png");
      }
    }

    .myScore {
      bottom: 11vh;
      height: 371px;
      flex-direction: column;
      background: url("~@/assets/images/event/Christmas2020/board2.png") center /
        100% auto no-repeat;
      z-index: 10;

      .msgBox {
        padding-bottom: 100px;
        cursor: default;

        section {
          font-size: 20px;
          width: 340px;
          height: 60px;
          line-height: 60px;
          font-weight: bold;
          color: $christmas2020_color_one;
        }

        &-left {
          float: left;
          margin-left: 1vw;
        }

        &-right {
          display: flex;
          justify-content: center;
          align-content: center;
          float: right;
          margin-right: 1vw;
        }

        .gift-icon {
          display: inline-block;
          width: 1.2vw;
          height: 1.2vw;
          margin: 2vh 0.8vh;
          background: url("~@/assets/images/event/Christmas2020/gift-icon.png")
            center / cover no-repeat;
        }
      }

      &__EN {
        background-image: url("~@/assets/images/event/Christmas2020/board2-EN.png");
      }
    }

    .enterBtn {
      bottom: 4vh;
      z-index: 2;

      section {
        display: flex;
        justify-content: center;
        width: 100%;

        a {
          display: block;
          width: 136px;
          height: 45px;
          line-height: 45px;
          text-align: center;
          border-radius: 10px;
          transition: 0.3s ease all;
          cursor: pointer;

          &:hover {
            box-shadow: 1px 2px 5px 3px #ff9bad;
            transform: scale(1.1);
          }
        }
      }

      &-py {
        background: url("~@/assets/images/event/Christmas2020/btn-py.png")
          center / contain no-repeat;

        &__EN {
          background-image: url("~@/assets/images/event/Christmas2020/btn-py-EN.png");
        }

        &-non {
          cursor: not-allowed;
          background: url("~@/assets/images/event/Christmas2020/btn-py-non.png")
            center / contain no-repeat;

          &__EN {
            background-image: url("~@/assets/images/event/Christmas2020/btn-py-EN-NON.png");
          }
        }
      }

      &-blocky {
        background: url("~@/assets/images/event/Christmas2020/btn-blocky.png")
          center / contain no-repeat;

        &__EN {
          background-image: url("~@/assets/images/event/Christmas2020/btn-blocky-EN.png");
        }

        &-non {
          cursor: not-allowed;
          background: url("~@/assets/images/event/Christmas2020/btn-blocky-non.png")
            center / contain no-repeat;

          &__EN {
            background-image: url("~@/assets/images/event/Christmas2020/btn-blocky-EN-NON.png");
          }
        }
      }
    }

    .rankSearch {
      position: fixed;
      right: 3vw;
      bottom: 6vw;
      width: 200px;
      height: 200px;
      background: url("~@/assets/images/event/Christmas2020/rankboardClick.png")
        center / cover no-repeat;
      cursor: pointer;

      &:hover {
        background-image: url("~@/assets/images/event/Christmas2020/rankboardClick-H.png");
      }

      &__EN {
        background-image: url("~@/assets/images/event/Christmas2020/rankboardClick-EN.png");

        &:hover {
          background-image: url("~@/assets/images/event/Christmas2020/rankboardClick-EN-H.png");
        }
      }
    }
  }

  &-rankBoard {
    display: flex;
    justify-content: center;
    align-items: center;

    &__container {
      position: fixed;
      width: 1035px;
      height: 850px;
      background: url("~@/assets/images/event/Christmas2020/dialog-bg.png")
        center / contain no-repeat;

      &__EN {
        background-image: url("~@/assets/images/event/Christmas2020/dialog-bg-EN.png");
      }

      .rankBoard {
        position: absolute;
        top: 275px;
        left: 140px;
        width: 724px;
        height: 370px;
        color: #461000;
        font-weight: bold;

        &-content {
          padding: 0 8px;

          // 修改board标签中的el-table元素属性
          .el-table {
            height: 330px;
            color: $christmas2020_color_one;
            background-color: transparent;

            tr,
            th,
            tr:hover > td {
              background-color: transparent;
            }

            td,
            th {
              border-bottom: unset;
            }

            &::before {
              display: none;
            }

            // ------------分割线------------

            &__header {
              thead {
                color: $christmas2020_color_one;
                font-size: 20px;
              }
              th {
                padding: 0;
                height: 40px;
                line-height: 40px;
              }
            }
            &__body {
              tr {
                height: 29px;
                line-height: 29px;
              }
              td {
                padding: unset;
              }
            }
          }

          .vipName {
            color: #f2a52a;
            font-weight: bold;
            text-shadow: -1px 0px 0px #5e3315, 1px 0px 0px #5e3315,
              0px 1px 0px #5e3315, 1px -1px 0px #5e3315;
          }

          .gift-icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 5px;
            background: url("~@/assets/images/event/Christmas2020/gift-icon.png")
              center / cover no-repeat;
          }

          .giftGetting {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        &-pagination {
          position: absolute;
          left: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 40px;
          color: #333;

          &__container {
            button {
              background: transparent;

              &:disabled {
                background: transparent;
              }

              i.el-icon {
                font-size: 16px;
                color: #000;
              }
            }

            ul li {
              font-size: 14px;
              font-weight: bold;
              background: transparent;

              &:hover,
              &.active {
                color: #1bb889;
              }
            }

            .el-pagination {
              button:disabled {
                background-color: unset;
              }
            }
          }
        }
      }

      .progressBar {
        position: absolute;
        left: 110px;
        bottom: 55px;
        padding: 10px 15px 0;
        color: #461000;

        .bar {
          position: relative;
          width: 755px;
          height: 25px;

          &:hover {
            .bar-count {
              opacity: 1;
              visibility: inherit;
              transform: matrix(1, 0, 0, 1, 0, 0);
            }
          }

          &-bg,
          &-top,
          &-count {
            position: absolute;
            left: 0;
            top: 0;
            width: 755px;
            height: 100%;
            border-radius: 100px;
          }

          &-count {
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            z-index: 22;
            cursor: default;
            opacity: 0;
            visibility: hidden;
            transition: all 0.4s ease-in-out;
            transform: matrix(1, 0, 0, 1, 0, -5);

            span {
              text-shadow: -1px 0px 0px #000, 1px 0px 0px #000, 0px 2px 0px #000,
                1px -2px 0px #000;
            }
          }

          &-bg {
            background-color: #59566d;
            box-shadow: inset 0 -3em 3em rgba(0, 0, 0, 0.102), 0 0 0 2px #fff,
              0.3em 0.3em 1em rgba(0, 0, 0, 0.302);
            z-index: 20;
          }

          &-top {
            z-index: 21;

            .el-progress-bar {
              height: 100%;
              padding-right: unset;
              margin-right: unset;

              &__outer {
                height: 100% !important;
                background-color: unset;
              }

              &__inner {
                background: url("~@/assets/images/event/Christmas2020/bar-wrapper.png")
                  center / cover repeat-y;
                animation: actions 1s linear infinite;
              }

              @keyframes actions {
                from {
                  background-position-y: 0;
                }

                to {
                  background-position-y: 25px;
                }
              }
            }

            .el-progress__text {
              display: none;
            }
          }
        }

        p {
          height: 20px;
          line-height: 20px;
          font-size: 18px;
          font-weight: bold;
          margin: 5px 0;
          cursor: default;
        }
      }

      .closeBtn {
        position: absolute;
        top: 100px;
        right: -120px;
        width: 110px;
        height: 115px;
        background: url("~@/assets/images/event/Christmas2020/closeBtn.png")
          no-repeat;
        cursor: pointer;
      }
    }

    .el-dialog {
      margin: 0 !important;
      width: 70vw;
      height: 85vh;
      box-shadow: unset;
      background: transparent;

      &__body {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 85vh;
        color: unset;
        padding: unset;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventChristmas.vue